import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import domainDetector from "./domain-detector";

const detector = new LanguageDetector();
detector.addDetector(domainDetector);

i18n
  .use(HttpBackend)
  .use(detector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: ["pl", "en"],
    ns: ["common", "landing", "auth", "dashboard", "wizard", "settings", "legal"],
    defaultNS: "common",
    detection: {
      order: ["domainDetector"],
    },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
